(function () {
  'use strict';

  // Skip in Shopify Design Mode (theme editor)
  if (window.Shopify && window.Shopify.designMode) return;

  // Reduced motion preference
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- Selectors ----
  // Target distinct content blocks — exclude image containers
  // (theme's rimg lazy-loader already fades images in independently)
  var REVEAL_SELECTORS = [
    // Hero / promotion (text only, not image)
    '.home-promotion-text',
    // Alternating content (left-right features)
    '.home-left-right-feature',
    // Text columns with images
    '.module-inline-item',
    // Featured collection
    '.dynamic-featured-collection .section-title',
    '.dynamic-featured-collection .collection-products',
    '.dynamic-featured-collection .home-module-cta',
    // Full-width feature (text elements only, not feature-image)
    '.home-full-width-feature .feature-title',
    '.home-full-width-feature .rte',
    '.home-full-width-feature .home-module-cta',
    // FAQ
    '.faq .section-header',
    '.faq .section-content',
    // Generic fallback for other sections
    '.module-container .section-title'
  ].join(', ');

  var STAGGER_SELECTORS = [
    '.home-left-right-features',
    '.home-inline-features'
  ].join(', ');

  // ---- Scroll Reveal ----
  function initScrollReveal() {
    var elements = document.querySelectorAll(REVEAL_SELECTORS);
    if (!elements.length) return;

    // Mark elements (skip nested ones and elements with lazy-loaded images)
    elements.forEach(function (el) {
      if (el.closest('.sr-reveal')) return;
      el.classList.add('sr-reveal');
    });

    // Mark stagger parents
    document.querySelectorAll(STAGGER_SELECTORS).forEach(function (parent) {
      var children = parent.querySelectorAll('.sr-reveal');
      if (children.length > 1) {
        parent.classList.add('sr-stagger');
      }
    });

    if (prefersReducedMotion) {
      document.querySelectorAll('.sr-reveal').forEach(function (el) {
        el.classList.add('sr-visible');
      });
      return;
    }

    // Wait for window load so rimg lazy-loader has finished with
    // above-the-fold images — avoids double-fade conflicts
    function startReveal() {
      var viewportHeight = window.innerHeight;
      var introElements = [];
      var scrollElements = [];

      document.querySelectorAll('.sr-reveal').forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < viewportHeight) {
          introElements.push(el);
        } else {
          scrollElements.push(el);
        }
      });

      // Above-the-fold: stagger with real delays
      introElements.forEach(function (el, i) {
        setTimeout(function () {
          el.classList.add('sr-visible');
        }, 100 + i * 150);
      });

      // Below-the-fold: IntersectionObserver
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sr-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.12,
        rootMargin: '-40px 0px'
      });

      scrollElements.forEach(function (el) {
        observer.observe(el);
      });
    }

    // Delay reveal until after images have loaded to avoid conflict with rimg
    if (document.readyState === 'complete') {
      startReveal();
    } else {
      window.addEventListener('load', startReveal);
    }
  }

  // ---- Init on DOM ready ----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }
})();
